(function() {
  'use strict';

  angular.module('ringbaPortal').component('userTaskActionsHistory', {
    bindings: {
      taskType: '@',
      actionsHistory: '<'
    },
    controllerAs: 'vm',
    controller: UserTaskActionsHistoryController,
    templateUrl: '/scripts/components/user-tasks/user-task-details/user-task-actions-history/user-task-actions-history.view.html'
  });

  function UserTaskActionsHistoryController(
    $filter
  ) {
    'ngInject';

    const vm = this;

    vm.translationString = {
      'CallVoid_Conversion': {
        'approve': 'CALL_VOID_APPROVE',
        'reject': 'CALL_VOID_REJECT',
        'amount': 'Conversion Adjustment Requested',
        'currentConversionAmount': 'Call Conversion Amount',
        'amountConversion': 'Conversion Adjusted',
        'amountPayout': 'Payout Adjusted',
        'reason': 'Reason'
      }
    };

    vm.filtersForArgs = {
      'CallVoid_Conversion': {
        'amount': _currencyFilter,
        'currentConversionAmount': _currencyFilter,
        'amountConversion': _currencyFilter,
        'amountPayout': _currencyFilter
      }
    };

    vm.$onChanges = onChanges;
    vm.checkNoExtraInfo = checkNoExtraInfo;

    function onChanges(changesObj) {
      if (changesObj.taskType && vm.taskType === 'CallVoid_Conversion') {
        vm.isCallVoid = true;
      }
    }

    function checkNoExtraInfo(actionArgs) {
      const keys = Object.keys(actionArgs);
      return actionArgs && keys.length === 1 && keys.indexOf('actionName') > -1;
    }

    function _currencyFilter(value) {
      return $filter('currency')(value, '$', 2);
    }

  }
})();
